import { Flex, VStack, Text, StackDivider } from '@chakra-ui/react';

import formatPriceNumber from '~/utils/formatPriceNumber';

import * as fp from 'lodash/fp';

type SettlementSectionProps = {
  displayList?: Array<{ label: string; price: number }>;
  total: number;
};

export default function SettlementSection({ displayList = [], total }: SettlementSectionProps) {
  return (
    <VStack align="stretch" spacing={3}>
      {displayList.map(({ label, price }) => (
        <Flex justify="space-between" key={label}>
          <Text>{label}</Text>
          <Text color={fp.lt(price, 0) ? 'danger.600' : 'fontColor'}>
            {fp.lt(price, 0) ? '-' : ''}
            {formatPriceNumber(Math.abs(price))}
          </Text>
        </Flex>
      ))}

      <StackDivider borderColor="dark" borderWidth={2} />

      <Flex justify="space-between">
        <Text fontWeight="bold">總計</Text>
        <Text fontWeight="bold">{formatPriceNumber(total)}</Text>
      </Flex>
    </VStack>
  );
}
